import * as React from "react";

import * as constants from "../constants";
import TeamDetailItem, { TeamDetailItemProps } from "./TeamDetailItem";
import TeamFullImg from "./TeamFullImg";
import Team from "./Team";

export interface TeamContainerProps {
  teamDetailItems?: TeamDetailItemProps[];
  teamFullImg?: string;
}

export interface TeamContainerState {
  showTeamFounders: boolean;
}

class TeamContainer extends React.Component<
  TeamContainerProps,
  TeamContainerState
> {
  public static defaultProps: Partial<TeamContainerProps> = {
    teamDetailItems: constants.TEAM_DETAIL_DATA,
    teamFullImg: constants.TEAM_FULL_IMG,
  };

  public state: TeamContainerState = {
    showTeamFounders: true,
  };

  private toggleTeamFounders = () =>
    this.setState(state => ({
      ...state,
      showTeamFounders: !state.showTeamFounders,
    }));

  private renderTeamDetailItems() {
    if (this.state.showTeamFounders) {
      return (this.props
        .teamDetailItems as TeamDetailItemProps[]).map((props, i) => (
        <TeamDetailItem key={i} {...props} />
      ));
    }

    return <TeamFullImg src={this.props.teamFullImg as string} />;
  }

  public render() {
    return (
      <Team toggleFounders={this.toggleTeamFounders}>
        {this.renderTeamDetailItems()}
      </Team>
    );
  }
}

export default TeamContainer;



// WEBPACK FOOTER //
// ./src/routes/Team/components/TeamContainer.tsx